module.exports = "<div>\n\t<input autocomplete='off' type='text' ng-model='selection' ng-focus='toggleVisible( true )' ng-blur='debounceDropdownVisible()' ng-model-options='{ debounce: 500 }' ng-keyup='checkVisible()'>\n\t<div class='dropdown' ng-show='dropdownVisible'>\n\t\t<ul>\n\t\t\t<li ng-repeat='item in data | filter: selection' ng-click='select(item)' class='dropdown-item'>{{ ::item }}</li>\n\t\t</ul>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/templates/bits/input-dropdown.html
// module id = 147
// module chunks = 0